import { motion } from "framer-motion";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarHeart } from "lucide-react";

interface DateStepProps {
  value: Date | undefined;
  onChange: (date: Date | undefined) => void;
  onNext: () => void;
}

const DateStep = ({ value, onChange, onNext }: DateStepProps) => {
  const handleSelect = (date: Date | undefined) => {
    onChange(date);
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="flex flex-col items-center text-center"
    >
      <div className="mb-6">
        <CalendarHeart className="w-12 h-12 text-primary mx-auto mb-4" />
        <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-2">
          When's the big day?
        </h2>
        <p className="text-muted-foreground">
          Select your wedding date so we can check our availability
        </p>
      </div>

      <div className="bg-card rounded-xl p-4 shadow-lg border border-border mb-6">
        <Calendar
          mode="single"
          selected={value}
          onSelect={handleSelect}
          disabled={(date) => date < new Date()}
          initialFocus
          className="pointer-events-auto"
        />
      </div>

      <Button
        onClick={onNext}
        disabled={!value}
        size="lg"
        className="w-full max-w-xs"
      >
        Check Availability
      </Button>
    </motion.div>
  );
};

export default DateStep;
